import { useQuery } from "@tanstack/react-query";

import { DEFAULT_LANGUAGE } from "app/pages/digital-marketing/generative-ai/llm-tracker/homepage/LLMSetupConst";
import type { ILanguage } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/types";

import type { IInitialTopicsResponse } from "../../services/getTopics";
import { getTopics } from "../../services/getTopics";

export const useInitialTopics = (domain: string, userId: number, options?: { enabled?: boolean }) => {
    return useQuery<IInitialTopicsResponse>({
        queryKey: ["llm-tracker", "initiate topics", domain],
        queryFn: () =>
            getTopics({
                domain,
                userId,
            }),
        retry: 1,
        gcTime: 0,
        staleTime: 0,
        refetchOnMount: "always",
        ...options,
    });
};

export const useUpdateTopics = (
    domain: string,
    userId: number,
    country: number,
    language: ILanguage,
    options?: { enabled?: boolean },
) => {
    return useQuery<IInitialTopicsResponse>({
        queryKey: ["llm-tracker", "update topics", domain, country, language],
        queryFn: () =>
            getTopics({
                domain,
                userId,
                country,
                cultureName: language?.id ?? DEFAULT_LANGUAGE.id,
            }),
        retry: 1,
        gcTime: 0,
        staleTime: 0,
        ...options,
    });
};
